import React, { useEffect } from "react";
import Sidebar from "./layout/sidebar/Sidebar";
import Header from "./layout/header/Header";
import { Routes, Route, useLocation } from "react-router";
import Dashboard from "./pages/dashboard/Dashboard";
import Learners from "./pages/learners/Learners";
//import Courses from "./pages/courses-beta/Courses";
import Courses from "./pages/courses/Courses";
import RewardRoutes from "./pages/rewards/RewardRoutes";
//import LearningPath from "./pages/learning-path-beta/PathRoutes";
//import Module from "./pages/module-beta/Module";
import Analytics from "./pages/analytics/Analytics";
import UserManagement from "./pages/user-management/UserManagement";
import BillingRoutes from "./pages/billing/site-admin/BillingRoutes";
import ClientBillingRoutes from "./pages/billing/client-admin/BillingRoutes";
import ActionPlanRoutes from "./pages/action-plan/ActionPlanRoute";
import CertificateRoutes from "./pages/certificate-editor/CertificateRoutes";
import Navbar from "./layout/header/Navbar";
import Clients from "./pages/clients/Client";
import Modules from "./pages/modules/Modules";
import Cohorts from "./pages/cohorts/Cohorts";
import LearningPath from "./pages/learningPath/LearningPath";
import RolesPrivilegesRoutes from "./pages/roles-and-priviledges/RolesPrivilegesRoutes";
// import AdminMangementRoute from "./pages/admin-management/AdminMangementRoute";
import EmailEditorRoutes from "./pages/email/EmailEditorRoutes";
import ZoomRoutes from "./pages/zoom/ZoomRoutes";
import SettingsRoutes from "./pages/settings/SettingsRoutes";
import Feedback from "./pages/feedback/Feedback";
import ContentRoutes from "./pages/content-libary/ContentRoutes";
import ReportRoute from "./pages/report/ReportRoute";
import AdminMangementRoute from "./pages/admin-management/AdminMangementRoute";
import { set } from 'date-fns';
import NotificationRoutes from "./pages/notifications/NotificationRoutes"

const AdminRoutes = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const accountType = user?.role?.slug;
  const isClientAdmin = accountType === "client-admin";
  const org = JSON.parse(sessionStorage.getItem('user'))
  const themes = sessionStorage.getItem('account-customization')
  const [isReportEditorRoutes, setIsReportEditorRoutes] = React.useState(false);
  const location = useLocation();

  useEffect( () => {
    if(location.pathname === '/admin/report/create' || location.pathname === '/admin/report/edit') {
      setIsReportEditorRoutes(true)
    } else setIsReportEditorRoutes(false)
    }, [location.pathname])

  return (
    <div className="flex justify-between overflow-y-hidden">
      { !isReportEditorRoutes &&
        <div className="w-[250px]">
        <Sidebar />
      </div>}
      <div className={`text-gray-900 ${
        isReportEditorRoutes ? 'w-[100%]' : 'w-[calc(100%-250px)]'
      }`}>
        <section 
          className={`h-[calc(100vh)] ${isReportEditorRoutes ? 'px-1' : 'px-5'} pt-2 admin-container-panel overflow-y-auto`}
          style={{
            backgroundColor : themes ? JSON.parse(themes)?.bodyColor :
            org?.orgAppearance?.bodyBackgroundColour || "#F2F4F7"
          }}
        >
          <Navbar />
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/clients/*" element={<Clients />} />
            <Route path="/learners/*" element={<Learners />} />
            <Route path="/course/*" element={<Courses />} />
            <Route path="/courses/module/*" element={<Modules />} />
            <Route path="/courses/analytics" element={<Analytics />} />
            <Route path="/cohort/*" element={<Cohorts />} />
            <Route path="/learning-path/*" element={<LearningPath />} />
            {
              isClientAdmin && 
              <Route path="/report/*" element={<ReportRoute />} />
            }
            <Route path="/user-management/*" element={<UserManagement />} />
            <Route
              path="/billing/*"
              element={
                isClientAdmin ? <ClientBillingRoutes /> : <BillingRoutes />
              }
            />
            <Route path="/rewards/*" element={<RewardRoutes />} />
            <Route path="/zoom/*" element={<ZoomRoutes />} />
            {/* <Route path="/settings/*" element={<SettingRoutes />} /> */}
            <Route path="/action-plan/*" element={<ActionPlanRoutes />} />
            <Route path="/settings/*" element={<SettingsRoutes />} />
            <Route path="/email/*" element={<EmailEditorRoutes />} />
            <Route path="/certificate/*" element={<CertificateRoutes />} />
            <Route path="/roles-and-privileges/*" element={<RolesPrivilegesRoutes />} />
            <Route path="/admins/*" element={<AdminMangementRoute />} />
            <Route path='/feedback/*' element={<Feedback />} />
            <Route path='/content-library/*' element={<ContentRoutes />} />
            <Route path='/notifications/*' element={<NotificationRoutes />} />
          </Routes>
        </section>
      </div>
    </div>
  );
};

export default AdminRoutes;
